import styled from "styled-components";

export const Container = styled.div``;

export const Input = styled.div`
  display: flex;

  width: fit-content;

  &.yes-or-no {
    button {
      &:first-child {
        border-radius: 0.25rem 0 0 0.25rem;
        border-right: 0;
      }

      &:last-child {
        border-radius: 0 0.25rem 0.25rem 0;
      }
    }
  }

  &.disabled {
    button {
      background-color: var(--input-disabled-background);
      border-color: var(--input-disabled-border);
      color: var(--input-disabled-border);
    }
  }
`;
